import { RootState } from ".."
import { PayloadAction, createSlice } from "@reduxjs/toolkit"

export const PAGE_STYLE = {
  GREEN: "green",
  BROWN: "brown",
  PURPLE: "purple",
  BROWN_LIGHT: "brown-light",
  BURGUNDY: "burgundy",
  TON: "ton",
  WINTER: "winter",
  PLUM: "plum",
  CUPID: "cupid",
  SUMMER: "summer",
  COMMON: "common",
  DARK_BLUE: "dark-blue"
} as const

export type IPageStyle = (typeof PAGE_STYLE)[keyof typeof PAGE_STYLE]

export const THEME = {
  COMMON: "common",
  WINTER: "winter",
  CUPID: "cupid",
  SUMMER: "summer"
} as const

export type ITheme = (typeof THEME)[keyof typeof THEME]

interface IApp {
  soundMute: boolean
  language: string
  clanMapScale: number
  isLoaded: boolean
  pageStyle: IPageStyle
  theme: ITheme
  isUnder: boolean
}

const getInitialIsUnder = (): boolean => {
  // return false
  const stored = localStorage.getItem("isUnder")
  return stored === "true"
}

export const initialState: IApp = {
  soundMute: false,
  language: "en",
  clanMapScale: 1,
  isLoaded: false,
  pageStyle: PAGE_STYLE.BROWN_LIGHT,
  isUnder: getInitialIsUnder(),
  theme: THEME.COMMON
}

export const AppSlice = createSlice({
  name: "app",
  initialState,
  reducers: {
    setSoundMute: (state, { payload }: PayloadAction<IApp["soundMute"]>) => {
      state.soundMute = payload
    },
    setLanguage: (state, { payload }: PayloadAction<IApp["language"]>) => {
      state.language = payload
    },
    setClanMapScale: (
      state,
      { payload }: PayloadAction<IApp["clanMapScale"]>
    ) => {
      state.clanMapScale = payload
    },
    setIsLoaded: (state, { payload }: PayloadAction<IApp["isLoaded"]>) => {
      state.isLoaded = payload
    },
    setPageStyle: (state, { payload }: PayloadAction<IApp["pageStyle"]>) => {
      state.pageStyle = payload
    },
    setTheme: (state, { payload }: PayloadAction<IApp["theme"]>) => {
      state.theme = payload
    },
    setIsUnder: (state, { payload }: PayloadAction<IApp["isUnder"]>) => {
      state.isUnder = payload
      localStorage.setItem("isUnder", String(payload))
    },
    toggleIsUnder: (state) => {
      state.isUnder = !state.isUnder
      localStorage.setItem("isUnder", String(state.isUnder))
    }
  }
})

const selectLanguage = () => (state: RootState) => {
  return state.app.language
}

const selectPageStyle = () => (state: RootState) => {
  return state.app.pageStyle
}

const selectTheme = () => (state: RootState) => {
  return state.app.theme
}

const selectIsUnder = () => (state: RootState) => {
  return state.app.isUnder
}

export const AppSelectors = {
  selectLanguage,
  selectPageStyle,
  selectTheme,
  selectIsUnder
}

export const {
  setSoundMute,
  setLanguage,
  setClanMapScale,
  setIsLoaded,
  setPageStyle,
  setTheme,
  setIsUnder,
  toggleIsUnder
} = AppSlice.actions
